import ShareCampaign from './share_campaign'
import { connect } from 'react-redux'
import { NEW_CAMPAIGN_ID } from 'redux/modules/campaign'
import {
  campaignUrlForDisplay,
  campaignUrlWithMeDomain,
} from 'lib/campaign_url'
import { canShareSelector } from 'redux/selectors/share'

const mapStateToProps = (state, { campaignId }) => {
  const canShare = canShareSelector(state)

  let props = {
    shareable: campaignId !== NEW_CAMPAIGN_ID,
    shareUrl: campaignUrlWithMeDomain(campaignId),
    displayUrl: campaignUrlForDisplay(campaignId),
    appId: state.social.app_id,
    showWhatsApp: !state.device_info.isDesktop,
  }

  if (!canShare) {
    props.showFacebook = false
    props.showMessenger = false
    props.showTwitter = false
    props.showWhatsApp = false
  }

  return props
}

const mapDispatchToProps = dispatch => {
  return {}
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ShareCampaign)
